import { render, staticRenderFns } from "./FAQSTable.vue?vue&type=template&id=b5736724"
import script from "./FAQSTable.vue?vue&type=script&lang=js"
export * from "./FAQSTable.vue?vue&type=script&lang=js"
import style0 from "./FAQSTable.vue?vue&type=style&index=0&id=b5736724&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports